const containerBannerHero = document.getElementById("section_banner_hero")
const containerBannerContent = document.getElementById("containerBannerContent")

function bannerMaxWidthToggle(){
    const windowSize = window.innerWidth
    if(windowSize < 1124){
        containerBannerHero.classList.remove("max-width")
        containerBannerContent.classList.add("max-width")
    } else {
        containerBannerHero.classList.add("max-width")
        containerBannerContent.classList.remove("max-width")
    }
}

bannerMaxWidthToggle();

window.addEventListener('resize', ()=>{
    bannerMaxWidthToggle()
})